import $ from 'jquery';

$(document).ready(function() {
  $(document.body).on('click', '.nav__item.nav__item_has_child > .nav__link', e => {
    e.preventDefault();

    const target = e.currentTarget;
    const $target = $(target);
    const $parent = $($target.parent().get(0));
    const opened = $parent.hasClass('opened');

    $parent.toggleClass('opened');
    $target.attr('aria-expanded', (_, attr) => {
      if (attr === 'false') {
        return 'true';
      }
      return 'false';
    });
    if (!opened) {
      $parent.siblings().removeClass('opened');
      $target
        .parent()
        .siblings()
        .find('.nav__link[aria-haspopup="true"]')
        .attr('aria-expanded', 'false');
    }
  });

  // close menu if user click outside menu
  $(document.body).on('click', e => {
    const { target } = e;
    const $target = $(target);

    if (!$target.hasClass('nav__link')) {
      const parents = $('.nav__item.nav__item_has_child.opened');
      const ariaLabels = $('.nav__item.nav__item_has_child.opened > .nav__link');
      ariaLabels.attr('aria-expanded', 'false');
      parents.removeClass('opened');
    }
  });

  // close when focus an element outside menu
  $(document).on('focusin', function(e) {
    const { target } = e;
    const $target = $(target);

    if (!$target.hasClass('nav__link')) {
      const parents = $('.nav__item.nav__item_has_child.opened');
      $target.attr('aria-expanded', (_, attr) => {
        if (attr === 'false') {
          return 'true';
        }
        return 'false';
      });

      parents.removeClass('opened');
    }
  });
});
